import { useEffect, useRef, useState } from 'react';

type Props = {
  length: number;
  columnWidth?: number;
};

const useCellEllipsisAsCount = (props: Props) => {
  const ref = useRef<HTMLDivElement>(null);

  const [numTagsToShow, setNumTagsToShow] = useState<number>(props.length);
  const [origChildrenWidths, setOrigChildrenWidths] = useState<number[] | null>(
    null,
  );

  useEffect(() => {
    setNumTagsToShow(props.length);
    setOrigChildrenWidths(null);
  }, [props.length]);

  useEffect(() => {
    if (ref.current) {
      let childrenWidths: number[] = [];
      if (origChildrenWidths === null) {
        const children = ref.current.children;
        for (let i = 0; i < children.length; i++) {
          const childWidth = Number.isNaN(children[i].scrollWidth)
            ? 0
            : children[i].scrollWidth;
          childrenWidths.push(childWidth);
        }
        setOrigChildrenWidths(childrenWidths);
      } else {
        childrenWidths = origChildrenWidths;
      }

      if (props.columnWidth !== undefined && childrenWidths.length > 0) {
        let accWidth = 36; // (+padding +numberOfHiddenTags)
        let t = 0;
        while (t < childrenWidths.length) {
          const childWidth = childrenWidths[t];
          if (childWidth === 0) continue;
          if (accWidth + childWidth > props.columnWidth) break;
          accWidth += childWidth + 4; // (+gap)
          t += 1;
        }
        setNumTagsToShow(t);
      }
    }
  }, [props.columnWidth, origChildrenWidths]);

  return {
    ref,
    numTagsToShow: Math.max(numTagsToShow, 1),
  };
};

export default useCellEllipsisAsCount;
